/* prettier-ignore */
const AIDOO = {
  TYPE: 'AIDOO',
  API_URL: process.env.VUE_APP_AIDOO_API_URL,
  HOST: process.env.VUE_APP_AIDOO_HOST,
  NAME: 'Airzone Aidoo',
  DEVICE: 'Wifi Controller device',
  LOGO: 'aidoo',
  SHOW_SUPPORT_EMAIL: false,
  STORE: {
    APPLE: 'https://itunes.apple.com/es/app/airzone-aidoo/id1468065088',
    ANDROID: 'https://play.google.com/store/apps/details?id=es.airzone.aidoo',
  },
  APP: {
    PRIVACY: {
      ES: '',
      EN: '',
    },
    TERMS: {
      ES: '',
      EN: '',
    },
    LEGAL: {
      ES: '',
      EN: '',
    },
  },
  ALEXA: {
    PRIVACY: {
      ES: 'http://doc.airzone.es/Certificates/Service/CERT_PRIVACY_ALEXA_AIDOO_ES.pdf',
      EN: 'http://doc.airzone.es/Certificates/Service/CERT_PRIVACY_ALEXA_AIDOO_EN.pdf',
    },
    TERMS: {
      ES: 'http://doc.airzone.es/Certificates/Service/CERT_TERMS_ALEXA_AIDOO_ES.pdf',
      EN: 'http://doc.airzone.es/Certificates/Service/CERT_TERMS_ALEXA_AIDOO_EN.pdf',
    },
  },
  GOOGLE: {
    PRIVACY: {
      ES: 'http://doc.airzone.es/Certificates/Service/CERT_PRIVACY_GOOGLE_AIDOO_ES.pdf',
      EN: 'http://doc.airzone.es/Certificates/Service/CERT_PRIVACY_GOOGLE_AIDOO_EN.pdf',
    },
    TERMS: {
      ES: 'http://doc.airzone.es/Certificates/Service/CERT_TERMS_GOOGLE_AIDOO_ES.pdf',
      EN: 'http://doc.airzone.es/Certificates/Service/CERT_TERMS_GOOGLE_AIDOO_EN.pdf',
    },
  },
};

/* prettier-ignore */
const DKNUSA = {
  TYPE: 'DKNUSA',
  API_URL: process.env.VUE_APP_DKNUSA_API_URL,
  HOST: process.env.VUE_APP_DKNUSA_HOST,
  NAME: 'DKN Cloud NA',
  DEVICE: 'Wifi Controller device',
  LOGO: 'dkn',
  SHOW_SUPPORT_EMAIL: true,
  STORE: {
    APPLE: 'https://itunes.apple.com/us/app/dkn-cloud-na/id1444432503',
    ANDROID: 'https://play.google.com/store/apps/details?id=io.airzone.dknNA',
  },
  APP: {
    PRIVACY: {
      EN: 'https://daikincomfort.com/privacy-policy',
      ES: 'https://dkncloudna.com/docs/CERT_PRIVACY_POLICY_DKNNA_ES.pdf',
      FR: 'https://dkncloudna.com/docs/CERT_PRIVACY_POLICY_DKNNA_FR.pdf',
    },
    TERMS: {
      EN: 'https://dknna.com/legal/terms/',
      ES: 'https://dknna.com/legal/terms/ES/',
      FR: 'https://dknna.com/legal/terms/FR/',
    },
    LEGAL: {
      EN: 'https://dknna.com/legal/eula/',
      ES: 'https://dknna.com/legal/eula/ES/',
      FR: 'https://dknna.com/legal/eula/FR/',
    },
  },
  ALEXA: {
    PRIVACY: {
      ES: '',
      EN: '',
    },
    TERMS: {
      ES: '',
      EN: '',
    },
  },
  GOOGLE: {
    PRIVACY: {
      ES: '',
      EN: '',
    },
    TERMS: {
      ES: '',
      EN: '',
    },
  },
};

/* prettier-ignore */
const DKNEU = {
  TYPE: 'DKNEU',
  API_URL: process.env.VUE_APP_DKNEU_API_URL,
  HOST: process.env.VUE_APP_DKNEU_HOST,
  NAME: 'DKN Cloud EU',
  DEVICE: 'Wifi Controller device',
  LOGO: 'dkn',
  SHOW_SUPPORT_EMAIL: false,
  STORE: {
    APPLE: 'https://itunes.apple.com/es/app/airzone-dkn-eu/id1453552189',
    ANDROID: 'https://play.google.com/store/apps/details?id=es.airzone.dknEU',
  },
  APP: {
    PRIVACY: {
      ES: 'http://doc.airzone.es/Certificates/Service/CERT_PRIVACIDAD_DKNEU_ES.pdf',
      EN: 'http://doc.airzone.es/Certificates/Service/CERT_PRIVACY_DKNEU_EN.pdf',
    },
    TERMS: {
      ES: 'http://doc.airzone.es/Certificates/Service/CERT_CONDICIONES_DKNEU_ES.pdf',
      EN: 'http://doc.airzone.es/Certificates/Service/CERT_TERMS_DKNEU_EN.pdf',
    },
    LEGAL: {
      ES: 'http://doc.airzone.es/Certificates/Service/CERT_AVISO_LEGAL_DKNEU_ES.pdf',
      EN: 'http://doc.airzone.es/Certificates/Service/CERT_LEGAL_NOTICE_DKNEU_EN.pdf',
    },
  },
  ALEXA: {
    PRIVACY: {
      ES: 'http://doc.airzone.es/Certificates/Service/CERT_PRIVACY_ALEXA_DKNEU_ES.pdf',
      EN: 'http://doc.airzone.es/Certificates/Service/CERT_PRIVACY_ALEXA_DKNEU_EN.pdf',
    },
    TERMS: {
      ES: 'http://doc.airzone.es/Certificates/Service/CERT_TERMS_ALEXA_DKNEU_ES.pdf',
      EN: 'http://doc.airzone.es/Certificates/Service/CERT_TERMS_ALEXA_DKNEU_EN.pdf',
    },
  },
  GOOGLE: {
    PRIVACY: {
      ES: 'http://doc.airzone.es/Certificates/Service/CERT_PRIVACY_GOOGLE_DKNEU_ES.pdf',
      EN: 'http://doc.airzone.es/Certificates/Service/CERT_PRIVACY_GOOGLE_DKNEU_EN.pdf',
    },
    TERMS: {
      ES: 'http://doc.airzone.es/Certificates/Service/CERT_TERMS_GOOGLE_DKNEU_ES.pdf',
      EN: 'http://doc.airzone.es/Certificates/Service/CERT_TERMS_GOOGLE_DKNEU_EN.pdf',
    },
  },
};

/* prettier-ignore */
const AZ = {
  TYPE: 'AZ',
  API_URL: process.env.VUE_APP_AZ_API_URL,
  HOST: process.env.VUE_APP_AZ_HOST,
  NAME: 'Airzone',
  DEVICE: 'System',
  LOGO: 'aidoo',
  SHOW_SUPPORT_EMAIL: false,
  STORE: {
    APPLE: 'https://itunes.apple.com/es/app/dkn-cloud/id999311567',
    ANDROID: 'https://play.google.com/store/apps/details?id=es.altra.dkn',
  },
  APP: {
    PRIVACY: {
      ES: '',
      EN: '',
    },
    TERMS: {
      ES: '',
      EN: '',
    },
    LEGAL: {
      ES: '',
      EN: '',
    },
  },
  ALEXA: {
    PRIVACY: {
      ES: '',
      EN: '',
    },
    TERMS: {
      ES: '',
      EN: '',
    },
  },
  GOOGLE: {
    PRIVACY: {
      ES: '',
      EN: '',
    },
    TERMS: {
      ES: '',
      EN: '',
    },
  },
};

function getProyectData() {
  const currentUrl = window.location.host;

  if (
    currentUrl.includes("dkneu") ||
    currentUrl.includes("predkneu") ||
    currentUrl.includes("devdknaeu")
  ) {
    return DKNEU;
  }

  if (
    currentUrl.includes("predknna") ||
    currentUrl.includes("devdknna") ||
    currentUrl.includes("dkncloudna") ||
    currentUrl.includes("logging")
  ) {
    return DKNUSA;
  }

  if (currentUrl.includes("az") || currentUrl.includes("devaz")) {
    return AZ;
  }

  return AIDOO;
}

// eslint-disable-next-line
export const PROYECT = getProyectData();
// export const PROYECT = DKNUSA;
